import { FC } from 'react';
import GenericSection from 'components/commercetools-ui/organisms/content/cms-components-v2/generic-section';
import SectionWithProductListing from 'components/commercetools-ui/organisms/content/cms-components-v2/section-with-product-listing';
import SectionWithProductSlider from 'components/commercetools-ui/organisms/content/cms-components-v2/section-with-product-slider';
import SectionWithProductGrid from 'components/commercetools-ui/organisms/content/cms-components-v2/section-with-product-grid';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import Link from 'components/commercetools-ui/atoms/link';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

export type CmsMasterContainerV2Props = {
  data?: any;
};

const ComponentRegistry: { [key: string]: React.ElementType } = {
  generic_section: GenericSection,
  section_with_product_listing: SectionWithProductListing,
  section_with_product_slider: SectionWithProductSlider,
  section_with_product_grid: SectionWithProductGrid,
  // add new content types here
};

const CmsMasterContainerV2: FC<CmsMasterContainerV2Props> = ({ data }) => {
  const renderComponents = () => {
    const componentList = [];
    const { sections = [] } = data ?? {};
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const sectionId = Object.keys(section)?.[0] ?? '';
      const Component = ComponentRegistry[sectionId];
      const dataToPass = section[sectionId];
      if (Component && dataToPass) {
        componentList.push(<Component key={i} content={dataToPass} />);
      }
    }
    return componentList;
  };

  const generateBreadcrumbs = () => {
    return (data?.breadcrumbs?.links ?? [])
    .filter((link: any) => link.title?.trim() && link.title?.trim().toLowerCase() != 'home')
    .map((link: any, index: number) => {
      const content = <span key={index} className={`text-14 font-normal leading-4 text-[#666] `}>{link.title}</span>;
      return link.href ? <Link key={index} link={link.href}>{content}</Link> : content;
    });
  };

  return <>
          {data?.breadcrumbs?.links?.[0]?.title &&
            <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
            <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
              <Link link={'/'}>
                <HomeIcon className="mt-6 w-20" />
              </Link>
              {generateBreadcrumbs()}
            </Breadcrumb>
            </div>
          }

          {renderComponents()}
        </>;
};

export default CmsMasterContainerV2;
